import { getIconRenderer } from './getIconRenderer';
import { IFeatureProperties } from '../../../../../types/map';
import { getIsHighlighted } from '../../getIsHighlighted';

export function getIcons(properties: IFeatureProperties): string {
  const { isViewed, isFavorite, icon } = properties.offers[0] || {};
  const iconProps = { isViewed, isHighlighted: getIsHighlighted(properties) };

  if (isFavorite) {
    return getIconRenderer('favorite', iconProps);
  }

  return icon ? getIconRenderer(icon, iconProps) : '';
}
